"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Will return a string representing the most recent policy source, depending on the provided
 * parameters.
 */
function getMostRecentPolicySource(_a) {
    var mostRecentCarPolicy = _a.mostRecentCarPolicy, carPolicyForLicense = _a.carPolicyForLicense, carPolicyForVin = _a.carPolicyForVin, carPolicyForMotor = _a.carPolicyForMotor;
    if (mostRecentCarPolicy) {
        if (typeof carPolicyForLicense !== 'undefined' &&
            carPolicyForLicense.policyId === mostRecentCarPolicy.policyId) {
            return 'licensePlate';
        }
        if (typeof carPolicyForVin !== 'undefined' &&
            carPolicyForVin.policyId === mostRecentCarPolicy.policyId) {
            return 'vinNumber';
        }
        if (typeof carPolicyForMotor !== 'undefined' &&
            carPolicyForMotor.policyId === mostRecentCarPolicy.policyId) {
            return 'motorNumber';
        }
    }
    return '';
}
exports.default = getMostRecentPolicySource;
//# sourceMappingURL=getMostRecentPolicySource.js.map